module.exports = __webpack_public_path__ + "static/img/img_appfaq.1c657e42.png";